(() => {
  if (window.__palvoraConsentRevocationReloadInstalled) return;
  window.__palvoraConsentRevocationReloadInstalled = true;

  const purposes = {
    analyticsAllowed: 'analyticsProcessingAllowed',
    marketingAllowed: 'marketingAllowed',
    preferencesAllowed: 'preferencesProcessingAllowed',
    saleOfDataAllowed: 'saleOfDataAllowed',
  };
  const previous = {};
  let reloadRequested = false;

  function reloadAfterRevocation(detail) {
    if (reloadRequested || !detail || typeof detail !== 'object') return;

    let revoked = false;
    for (const purpose of Object.keys(purposes)) {
      if (typeof detail[purpose] !== 'boolean') continue;
      if (previous[purpose] === true && detail[purpose] === false) revoked = true;
      previous[purpose] = detail[purpose];
    }

    if (revoked) {
      reloadRequested = true;
      try {
        window.location.reload();
      } catch (_) {}
    }
  }

  document.addEventListener('visitorConsentCollected', (event) => {
    reloadAfterRevocation(event.detail);
  });

  function seedInitialState() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return;

    for (const [purpose, method] of Object.entries(purposes)) {
      if (typeof previous[purpose] === 'boolean') continue;
      try {
        if (typeof privacy[method] !== 'function') continue;
        const allowed = privacy[method]();
        if (typeof allowed === 'boolean') previous[purpose] = allowed;
      } catch (_) {}
    }
  }

  const shopify = window.Shopify;
  if (!shopify) return;
  if (shopify.customerPrivacy) {
    seedInitialState();
  } else if (typeof shopify.loadFeatures === 'function') {
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) seedInitialState();
      });
    } catch (_) {}
  }
})();
